import { createContext } from 'react';
/** @private Internal context. Do not use in your production. */
const SliderInternalContext = createContext({});
export default SliderInternalContext;
